<template>
  <div class="vr360-wrap" id="app">

    <spinner />

    <transition name="vr360-notification">
      <notification />
    </transition>
    
    <router-view/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import setts from "@/config/setts";

import isMobile from "@/assets/js/checkMobile";

import Spinner from "@/components/partials/Spinner";
import Notification from "@/components/partials/Notification";

export default {
  components: {
    Notification,
    Spinner
  },
  created() {
    if (!isMobile()) {
      document.body.classList.add("opened-desktop");
      if (!localStorage.getItem("showOnDesktop")) {
        this.$router.replace({ name: "OpenInMobile" });
        return false;
      }
    }
   

    this.checkAuth();

    this.checkConnection();

    this.$router.beforeEach((to, from, next) => {
      if (to.matched.some(record => record.meta.forVisitors)) {
        if (this.isAuthenticated) {
          next({
            name: setts.DEFAULT_APP_URL
          });
        } else next();
      } else if (to.matched.some(record => record.meta.forAuth)) {
        if (!this.isAuthenticated) {
          next({
            name: "Login"
          });
        } else next();
      } else next();
    });
  },
  methods: {
    ...mapActions({
      checkConnection: "checkConnection",
      checkAuth: "user/checkAuth"
    })
  },
  watch: {
    $route(val) {
      if (isMobile() && val.name === "OpenInMobile") {
        this.$router.replace({ name: setts.DEFAULT_APP_URL });
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "user/isAuthenticated"
    })
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vr360-styles.scss";
</style>
